import { render, staticRenderFns } from "./Makers.vue?vue&type=template&id=7ffd8340&scoped=true"
import script from "./Makers.vue?vue&type=script&lang=js"
export * from "./Makers.vue?vue&type=script&lang=js"
import style0 from "./Makers.vue?vue&type=style&index=0&id=7ffd8340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd8340",
  null
  
)

export default component.exports